<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <!-- หัวข้อ -->
      <!-- <div v-show="almost_mobile" style="margin-top: 15%"></div> -->
      <h3 class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        เยี่ยมบ้าน
      </h3>
      <v-row class="mx-1 my-2 mt-8">
        <v-spacer></v-spacer>
        <v-col cols="12" lg="auto" md="auto" sm="auto" class="pr-0">
          <v-btn block color="#00a99d" outlined @click="AppointmentHomeVisit()" class="card-small2">
            <v-icon color="#00a99d">mdi-calendar-outline</v-icon>
            <span class="pl-2">ปฏิทินลงพื้นที่</span>
          </v-btn>
        </v-col>
        <v-col cols="12" lg="auto" md="auto" sm="auto" class="pr-0">
          <v-btn block color="#00a99d" dark @click="ExportFile()" class="card-small">
            <v-icon color="#FFFFFF">mdi-microsoft-excel</v-icon>
            <span class="pl-2" style="text-transform: capitalize">Export</span>
          </v-btn>
        </v-col>
      </v-row>
    
      <!-- แท็บ -->
      <v-row class="mr-1 my-2 mt-8" style="justify-content:center">
        <!-- แท็บ ทั้งหมด -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 20%"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(0)"
            :class="status === 0 ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex align-center justify-start pl-6"
              >
                <v-img 
                  :src="status === 0 ? require('@/assets/icon/Telepharma/all-dark.svg') : require('@/assets/icon/Telepharma/all-light.svg')"
                  class="mr-5 px-3 py-4"
                  :class="status === 0 ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 0 ? 'text-ffffff' : 'text-00a99d'"><h3>{{ summaryList.total_all }}</h3></span>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 0 ? 'text-ffffff' : 'text-00a99d'">ทั้งหมด</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- แท็บ รอเยี่ยมบ้าน -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 20%"
          class="pt-0 pr-0"
        >
        <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(1)"
            :class="status === 1 ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex align-center justify-start pl-6"
              >
                <v-img 
                  :src="require('@/assets/icon/Telepharma/register.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status === 1 ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 1 ? 'text-ffffff' : 'text-00a99d'"><h3>{{ summaryList.total_regis }}</h3></span>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 1 ? 'text-ffffff' : 'text-00a99d'">รอเยี่ยมบ้าน</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- แท็บ กำลังดำเนินการ -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 20%"
          class="pt-0 pr-0"
        >
        <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(2)"
            :class="status === 2 ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex align-center justify-start pl-6"
              >
              <v-img 
                  :src="require('@/assets/icon/Telepharma/transport.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status === 2 ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 2 ? 'text-ffffff' : 'text-00a99d'"><h3>{{ summaryList.total_waiting }}</h3></span>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 2 ? 'text-ffffff' : 'text-00a99d'">กำลังดำเนินการ</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- แท็บ เสร็จสิ้น -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 20%"
          class="pt-0 pr-0"
        >
        <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(3)"
            :class="status === 3 ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex align-center justify-start pl-6"
              >
              <v-img 
                  :src="require('@/assets/icon/Telepharma/success.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status === 3 ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 3 ? 'text-ffffff' : 'text-00a99d'"><h3>{{ summaryList.total_complete }}</h3></span>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 3 ? 'text-ffffff' : 'text-00a99d'">เสร็จสิ้น</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- แท็บ ยกเลิก -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 20%"
          class="pt-0 pr-0"
        >
        <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet(4)"
            :class="status === 4 ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col
                cols="12"
                class="d-flex align-center justify-start pl-6"
              >
              <v-img 
                  :src="require('@/assets/icon/Telepharma/cancel.svg')"
                  class="mr-5 pb-2 pa-3"
                  :class="status === 4 ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 4 ? 'text-ffffff' : 'text-00a99d'"><h3>{{ summaryList.total_cancel }}</h3></span>
                  </v-col>
                  <v-col cols="12" class="py-0 d-flex align-center justify-center">
                    <span :class="status === 4 ? 'text-ffffff' : 'text-00a99d'">ยกเลิก</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- ค้นหา -->
      <v-row class="mx-1 mb-6">
        <v-col cols="12" lg="4" xl="4" :class="status == 0 ? 'card-search-start':''">
          <v-row>
            <v-col cols="12" class="pa-2 card-small">
                <v-text-field 
                v-model="search" 
                class="card-small hide-hint" 
                hint="กด Enter เพื่อค้นหา" 
                dense solo hide-details="auto" 
                append-icon="mdi-magnify" 
                clearable 
                clear-icon="mdi-close-circle"
                @click:clear="(search = '', getHomeVisitList())" 
                @keypress.enter="getHomeVisitList" 
                color="#00A99D"
                >
                <template slot="label">
                  <span class="font-14">กรุณากรอก HN, ชื่อ-สกุล และ เบอร์โทรศัพท์ เพื่อค้นหา</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row> 
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" lg="2" xl="2" :class="status == 0 ? 'card-search-middle':'card-search-start'" style="align-self: start;">
          <v-row>
            <v-col cols="12" class="pa-2 card-small">
              <v-text-field 
                v-model="select_appointment_no" 
                hint="กด Enter เพื่อค้นหา"
                dense 
                solo 
                hide-details="auto" 
                append-icon="mdi-magnify" 
                clearable 
                clear-icon="mdi-close-circle"
                class="card-small hide-hint"
                @click:clear="(select_appointment_no = '', getHomeVisitList())" 
                @keypress.enter="getHomeVisitList" 
                color="#00A99D">
                <template slot="label">
                  <span class="font-14">กรุณากรอกครั้งที่นัดหมาย</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="status == 0" cols="12" lg="2" xl="2" class="card-search-middle" style="align-self: start;">
          <v-row>
            <v-col cols="12" class="pa-2 card-small">
              <v-select
                hide-details
                solo
                dense
                :menu-props="{ bottom: true, offsetY: true }"
                v-model="select_status"
                :items="status_list"
                item-text="text"
                item-value="value"
                @input="getHomeVisitList"
                color="#00A99D"
                item-color="teal darken-2"
                class="card-small"
              >
                <template slot="append">
                  <v-btn text icon>
                    <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <template v-slot:item="{ item }">
                  <span class="font-14">{{ item.text }}</span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="2" xl="2" class="card-search-middle"  style="align-self: start;">
          <v-row>
            <v-col cols="12" :class="status !== 0 ? 'pa-2 card-search-start' : 'pa-2 card-search-middle'">
              <v-select
                hide-details
                solo
                dense
                :menu-props="{ bottom: true, offsetY: true }"
                v-model="select_urgency"
                :items="urgency_list"
                item-text="text"
                item-value="value"
                @input="getHomeVisitList"
                color="#00A99D"
                item-color="teal darken-2"
                class="card-small"
              >
                <template slot="append">
                  <v-btn text icon>
                    <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <template v-slot:item="{ item }">
                  <span class="font-14">{{ item.text }}</span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="2" xl="2" class="card-search-end"  style="align-self: start;">
          <v-row>
            <v-col cols="12" class="pa-2">
              <v-menu v-model="day_menu" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="350px" min-width="auto" bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field solo dense append-icon="mdi-calendar-multiselect" placeholder="วัน/เดือน/ปี"
                    :value="displayDate()" readonly v-bind="attrs" hide-details v-on="on" color="#00A99D" v-model="dateRangeText"
                    item-color="teal darken-2" class="card-small">
                    <template slot="append">
                      <v-btn text icon v-on="on">
                        <v-icon color="#00A99D">mdi-calendar-multiselect</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="day_select" no-title scrollable range locale="th" color="#00A99D">
                  <v-spacer></v-spacer>
                  <v-btn text color="#00A99D" @click="day_menu = false, getHomeVisitList()">
                    ตกลง
                  </v-btn>
                  <v-btn text color="#00A99D" @click="clearDaySelect(), getHomeVisitList()">
                    ล้างค่า/clear
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- ตาราง -->
      <v-row class="mb-3">
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="status == 0 ? headersTable : status == 2 ? headersTable2 : headersTable1"
            :items="itemTable"
            hide-default-footer
            :loading="loadingTable"
            loading-text="กำลังโหลดข้อมูล"
            class="px-0"
            disable-sort
            :expanded.sync="expanded"
            item-key="_id"
            show-expand
            single-expand
          >
            <template v-slot:no-data>
              <span class="font-16">ไม่มีข้อมูล</span>
            </template>

            <template v-slot:progress>
              <v-progress-linear
                indeterminate
                height="3px"
                color="#00A99D"
                class="mx-0"
              ></v-progress-linear>
            </template>

            <!-- -------------------------------------- ลำดับที่ ----------------------------------- -->
            <template v-slot:[`item.No`]="{ index }">
              <div class="d-flex flex-column">
                <span class="font-14 text-navy-50">{{
                  index + 1 + (page - 1) * limit
                }}</span>
              </div>
            </template>

            <!-- -------------------------------------- ครั้งที่ ----------------------------------- -->
            <template v-slot:[`item.appointment_no`]="{ item }">
              <div class="d-flex flex-column">
                <span v-if="'appointment_no' in item && item.appointment_no !== '' && item.appointment_no !== null && item.appointment_no !== undefined" class="font-14 text-navy-50">{{ item.appointment_no || "-" }}</span>
                <span v-else class="font-14 text-navy-50">-</span>
              </div>
            </template>

            <!-- --------------------------------------ชื่อผู้ใช้บริการ----------------------------------- -->
            <template v-slot:[`item.name`]="{ item }">
              <div class="d-flex flex-column">
                <span class="font-14 text-00A99D">HN : <span v-if="'HN' in item && item.HN !== '' && item.HN !== null && item.HN !== undefined" class="font-14 text-navy-50">{{ item.HN || "-" }}</span>
                <span v-else class="font-14 text-navy-50">-</span></span>
                <span class="font-14 text-00A99D">ชื่อ : <span v-if="'fullname' in item && item.fullname !== '' && item.fullname !== null && item.fullname !== undefined" class="font-14 text-navy-50">{{ item.fullname || '-' }}</span>
                <span v-else class="font-14 text-navy-50">-</span></span>
                <span class="font-14 text-00A99D">เบอร์โทร : <span v-if="'mobile' in item && item.mobile !== '' && item.mobile !== null && item.mobile !== undefined" class="font-14 text-navy-50">{{ mobile(item.mobile) }}</span>
                <span v-else class="font-14 text-navy-50">-</span></span>
              </div>
            </template>

            <!-- --------------------------------------วันที่นัดหมาย----------------------------------- -->
            <template v-slot:[`item.slot_date`]="{ item }">
              <div v-if="'slot_date' in item && item.slot_date !== '' && item.slot_date !== null && item.slot_date !== undefined" class="d-flex flex-column">
                <span class="font-14 text-00A99D">{{ showDate(item.slot_date) }}</span>
                <span v-if="item.start_time && item.end_time" class="font-14 text-navy-50">{{ item.start_time+'-'+item.end_time }} น.</span>
                <span v-else class="font-16 text-navy-50">-</span>
              </div>
              <div class="d-flex flex-column font-14 text-00A99D" v-else>-</div>
            </template>

            <!-- --------------------------------------doctor_name ทีมแพทย์----------------------------------- -->
            <template v-slot:[`item.doctor_name`]="{ item }">
              <span v-if="'doctor_name' in item && item.doctor_name !== '' && item.doctor_name !== null && item.doctor_name !== undefined && item.doctor_name !== 'undefined undefined'" class="font-14 text-navy-50">{{ item.doctor_name }}</span>
              <span v-else class="font-14 text-navy-50">-</span>
            </template>

            <!-- --------------------------------------target_group กลุ่มเป้าหมาย----------------------------------- -->
            <template v-slot:[`item.target_group`]="{ item }">
              <span v-if="'target_group' in item && item.target_group !== '' && item.target_group !== null && item.target_group !== undefined" class="font-14 text-navy-50">{{ item.target_group }}</span>
              <span v-else class="font-14 text-navy-50">-</span>
            </template>

            <!-- --------------------------------------urgency ความเร่งด่วน----------------------------------- -->
            <template v-slot:[`item.urgency`]="{ item }">
              <v-btn v-if="'urgency' in item && item.urgency !== '' && item.urgency == '1'" rounded depressed color="#2cc63b3b" small style="cursor: inherit;">
                <v-row>
                  <v-col cols="12" align-self="center">
                    <v-icon color="#2CC63B" size="12">mdi-circle</v-icon><span class="pl-1 font-12 text-2CC63B">เร่งด่วนปกติ</span>
                  </v-col>
                </v-row>
              </v-btn>
              <v-btn v-else-if="'urgency' in item && item.urgency !== '' && item.urgency == '2'" rounded depressed color="#f1ce9785" small style="cursor: inherit;">
                <v-row>
                  <v-col cols="12" align-self="center">
                    <v-icon color="#fe9c05" size="12">mdi-circle</v-icon><span class="pl-1 font-12 text-fe9c05">เร่งด่วนปานกลาง</span>
                  </v-col>
                </v-row>
              </v-btn>
              <v-btn v-else-if="'urgency' in item && item.urgency !== '' && item.urgency == '3'" rounded depressed color="#f38c8cad" small style="cursor: inherit;">
                <v-row>
                  <v-col cols="12" align-self="center">
                    <v-icon color="#f3051a" size="12">mdi-circle</v-icon><span class="pl-1 font-12 text-f3051a">เร่งด่วนมาก</span>
                  </v-col>
                </v-row>
              </v-btn>
              <span v-else class="font-16 text-navy-50">-</span>
            </template>

            <!-- --------------------------------------สถานะ----------------------------------- -->
            <template v-slot:[`item.status`]="{ item }">
                <v-row v-if="'status' in item && item.status !== '' && item.status == '1'">
                  <v-col cols="12" align-self="center">
                    <span class="pl-1 font-14 text-296ED5">รอเยี่ยมบ้าน</span>
                  </v-col>
                </v-row>
                <v-row v-else-if="'status' in item && item.status !== '' && item.status == '2'">
                  <v-col cols="12" align-self="center">
                    <span class="pl-1 font-14 text-FFB649">กำลังดำเนินการ</span>
                  </v-col>
                </v-row>
                <v-row v-else-if="'status' in item && item.status !== '' && item.status == '3'">
                  <v-col cols="12" align-self="center">
                    <span class="pl-1 font-14 text-1CCE39">เสร็จสิ้น</span>
                  </v-col>
                </v-row>
                <v-row v-else-if="'status' in item && item.status !== '' && item.status == '4'">
                  <v-col cols="12" align-self="center">
                    <span class="pl-1 font-14 text-FF6270">ยกเลิก</span>
                  </v-col>
                </v-row>
              <span v-else class="font-16 text-navy-50">-</span>
            </template>

            <!-- action -->
            <!-- <template v-slot:[`item.action`]="{ item, index }"> -->
            <template v-slot:[`item.action`]="{ item }">
              <div class="d-flex flex-row" style="justify-content:center">
                <div v-if="item.status == '1' || item.status == '3'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        class="py-4 px-2 mx-1 image-border"
                        style="max-width: 24px; border: 1px solid #F2F2F2"
                        @click="select_form(item, 'register')"
                      >
                        <v-icon color="#00a99d">mdi-file-document-plus-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>เลือกแบบฟอร์ม</span>
                  </v-tooltip>
                </div>
                <div  v-if="item.status == '4'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        class="py-4 px-2 mx-1 image-border"
                        style="max-width: 24px; border: 1px solid #F2F2F2"
                        @click="booking(item, 'revert')"
                      >
                        <v-icon color="#00a99d">mdi-keyboard-return</v-icon>
                      </v-btn>
                    </template>
                    <span>ย้อนกลับ</span>
                  </v-tooltip>
                </div>
                <!-- <div v-if="item.status == '1' || item.status == '2'"> -->
                <div v-if="item.status == '1'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        class="py-4 px-2 mx-1 image-border"
                        style="max-width: 24px; border: 1px solid #F2F2F2"
                        @click="cancel(item, 'cancel')"
                      >
                        <v-icon width="28" color="#E26269"
                          >mdi-close-thick</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>ยกเลิก</span>
                  </v-tooltip>
                </div>
                <div v-if="item.status == '4'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        class="py-4 px-2 mx-1 image-border"
                        style="max-width: 24px; border: 1px solid #f2f2f2"
                        @click="cancel(item, 'see')"
                      >
                        <v-icon color="#00A99D">mdi-file-cancel-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>ดูหมายเหตุการยกเลิก</span>
                  </v-tooltip>
                </div>
              </div>
            </template>

            <template v-slot:[`item.data-table-expand`]="{ index, item, expand, isExpanded }">
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab text small color="#FFFFFF" @click="expand(!isExpanded), checkIndex(index), nextListForm(item)" v-if="item.status == '2' || item.status == '3'"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        :style="isExpanded ? 'transform: rotate(-180deg);' : ''"
                        color="#00a99d"
                      >mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="!isExpanded">รายการแบบฟอร์ม</span>
                  <span v-else>ย่อ</span>
                </v-tooltip>
              </td>
            </template>

            <template v-if="item.status !== '1' || (item.status == '4' && item.form_list.length !== 0)" v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="py-1">
                <v-row v-for="(value, index2) in item.form_list" :key="index2">
                  <v-col v-if="((pageForm-1)*5 <= index2) && index2 < (pageForm*5)" cols="12">
                    <v-card flat color="#ebf7f7" class="card-form_list py-2">
                      <v-row>
                        <v-col cols="3" xl="1" lg="1" md="1" sm="1" class="pr-0" align="end">
                          <Doc :class="display_vuetify == 'xs' ? 'mx-1 icon-image': 'mx-5 icon-image'" />
                        </v-col>
                        <v-col cols="8" xl="6" lg="6" md="6" sm="6" class="pl-0" align-self="center">
                          <span :class="display_vuetify == 'xs' ? 'font-12 w-500 text-navy-50' : 'font-14 w-500 text-navy-50'">{{ value.form_name }}</span>
                        </v-col>
                        <v-col cols="12" xl="2" lg="2" md="2" sm="2" align-self="center" align="center">
                          <v-btn v-if="'status' in value && value.status !== '' && value.status == 'success'" rounded depressed color="#2cc63b3b" small style="cursor: inherit;">
                            <v-row>
                              <v-col cols="12" align-self="center">
                                <v-icon color="#2CC63B" size="12">mdi-circle</v-icon><span class="pl-1 font-12 text-2CC63B">เสร็จสิ้น</span>
                              </v-col>
                            </v-row>
                          </v-btn>
                          <v-btn v-else-if="'status' in value && value.status !== '' && value.status == 'wait'" rounded depressed color="#f1ce9785" small style="cursor: inherit;">
                            <v-row>
                              <v-col cols="12" align-self="center">
                                <v-icon color="#fe9c05" size="12">mdi-circle</v-icon><span class="pl-1 font-12 text-fe9c05">กำลังดำเนินการ</span>
                              </v-col>
                            </v-row>
                          </v-btn>
                          <v-btn v-else-if="'status' in value && value.status !== '' && value.status == 'cancel'" rounded depressed color="#f38c8cad" small style="cursor: inherit;">
                            <v-row>
                              <v-col cols="12" align-self="center">
                                <v-icon color="#f3051a" size="12">mdi-circle</v-icon><span class="pl-1 font-12 text-f3051a">ยกเลิก</span>
                              </v-col>
                            </v-row>
                          </v-btn>
                          <span v-else class="font-16 text-navy-50">-</span>
                        </v-col>
                        <v-col cols="12" xl="3" lg="3" md="3" sm="3" align-self="center" style="justify-content: center;" class="d-flex d-flex-row">
                          <div v-if="'status' in value && value.status !== '' && value.status == 'wait'">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  small
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                  class="py-4 px-2 mx-1 image-border"
                                  style="max-width: 24px; border: 1px solid #F2F2F2"
                                  @click="check_form(item, value, 'register')"
                                >
                                  <v-icon color="#00a99d">mdi-file-document-edit</v-icon>
                                </v-btn>
                              </template>
                              <span>กรอกแบบฟอร์ม</span>
                            </v-tooltip>
                          </div>
                          <div v-if="'status' in value && value.status !== ''">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  small
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                  class="py-4 px-2 mx-1 image-border"
                                  style="max-width: 24px; border: 1px solid #F2F2F2"
                                  @click="check_form(item, value, 'detail')"
                                >
                                  <v-img
                                    :src="
                                      require('@/assets/icon/Telepharma/eye-outline.svg')
                                    "
                                    style=" hight:12px; width:12px"
                                  />
                                </v-btn>
                              </template>
                              <span>ดูรายละเอียด</span>
                            </v-tooltip>
                          </div>
                          <div v-if="'status' in value && value.status !== '' && value.status == 'success'">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  small
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                  color="#00a99d"
                                  class="py-4 px-2 mx-1 image-border"
                                  style="max-width: 24px; border: 1px solid #F2F2F2"
                                  :loading="value.loading_PDF"
                                  @click="PDF_Dialog(item, value, index2)"
                                >
                                  <v-icon color="#00a99d">mdi-file-pdf-box</v-icon>
                                </v-btn>
                              </template>
                              <span>ดาวน์โหลด PDF</span>
                            </v-tooltip>
                          </div>
                          <div v-if="'status' in value && value.status !== '' && value.status == 'wait'">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  small
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                  class="py-4 px-2 mx-1 image-border"
                                  style="max-width: 24px; border: 1px solid #F2F2F2"
                                  @click="cancelForm(item, value, 'cancel')"
                                >
                                  <v-icon width="28" color="#E26269"
                                    >mdi-close-thick</v-icon
                                  >
                                </v-btn>
                              </template>
                              <span>ยกเลิก</span>
                            </v-tooltip>
                          </div>
                          <div v-if="'status' in value && value.status !== '' && value.status == 'cancel' ">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  small
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                  class="py-4 px-2 mx-1 image-border"
                                  style="max-width: 24px; border: 1px solid #f2f2f2"
                                  @click="cancelForm(item, value, 'see')"
                                >
                                  <v-icon color="#00A99D">mdi-file-cancel-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>ดูหมายเหตุการยกเลิก</span>
                            </v-tooltip>
                          </div>
                          <div v-if="checkCopyForm(item, value)">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  small
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                  class="py-4 px-2 mx-1 image-border"
                                  style="max-width: 24px; border: 1px solid #f2f2f2"
                                @click="copyForm(item, value, 'register')"
                                >
                                  <v-icon color="#00A99D">mdi-file-document-multiple-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>คัดลอก</span>
                            </v-tooltip>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row v-if="item.form_list.length > 5">
                  <v-col cols="12" align="center">
                    <v-pagination
                      v-model="pageForm"
                      :length="totalForm"
                      circle
                      color="#00a99d"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <Pagination :totals="total" :isPage="page" @page="changePage" />
    </v-container>
    <ExportFile ref="export" />
    <HomeVisitBooking ref="booking" @close="getHomeVisitList" @status_type="status_type" />
    <CancelBooking ref="cancel" @close="getHomeVisitList" @status_type="status_type"/>
    <CancelForm ref="cancelForm" @close="getHomeVisitList" @status_type="status_type"/>
    <RegisterDialog ref="registerDialog" @close="getHomeVisitList" @status_type="status_type"/>
    <PDFDialog ref="PDF_Dialog"  @loading="loading_PDF_Dialog"/>
    <FormDisabledPerson ref="formDisabledPerson" @close="getHomeVisitList" @status_type="status_type"/>
    <FormElderlyPerson ref="formElderlyPerson" @close="getHomeVisitList" @status_type="status_type"/>
    <SelectFormAndPerson ref="selectFormAndPerson" @close="getHomeVisitList"  @viewForm="viewFormHomeVisit" @status_type="status_type"/>
    
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import ExportFile from './ExportFile.vue';
import HomeVisitBooking from "./HomeVisitBooking.vue";
import CancelBooking from "./CancelBooking.vue";
import CancelForm from "./CancelForm.vue";
import RegisterDialog from "../HomeVisit/RegisterDialog.vue";
import PDFDialog from "../HomeVisit/PDF_Dialog.vue";
import { Pagination } from "@/components/pagination";
import FormDisabledPerson from "@/views/HomeVisit/FormHomeVisit/FormDisabledPerson.vue"
import FormElderlyPerson from "@/views/HomeVisit/FormHomeVisit/FormElderlyPerson.vue"
import SelectFormAndPerson from "@/views/HomeVisit/FormHomeVisit/SelectFormAndPerson.vue"
import Doc from "@/assets/icon/Doc.vue"

export default {
  components: {
    ExportFile,
    HomeVisitBooking,
    CancelBooking,
    CancelForm,
    RegisterDialog,
    PDFDialog,
    Pagination,
    FormDisabledPerson,
    FormElderlyPerson,
    SelectFormAndPerson,
    Doc,
  },
  data() {
    return {
      pageForm: 1,
      totalForm: 0,
      expanded: [],
      summaryList: { 
        total_all: 0,
        total_regis: 0,
        total_waiting: 0,
        total_complete: 0,
        total_cancel: 0
      },
      item: {},
      shared_token: "",
      search: '',
      status: 0,
      page: 1,
      limit: 10,
      total: 0,
      headersTable: [
        {
          text: "ลำดับที่",
          align: "center",
          value: "No",
          width: "5%",
        },
        {
          text: "ครั้งที่",
          align: "center",
          value: "appointment_no",
          width: "5%",
        },
        {
          text: "ชื่อผู้ใช้บริการ",
          align: "start",
          value: "name",
          width: "220px", 
          // width: "300px"
        },
        {
          text: "วันเวลาที่นัดหมาย",
          value: "slot_date",
          width: "15%",
        },
        {
          text: "ทีมแพทย์",
          value: "doctor_name",
          width: "160px",
        },
        {
          text: "กลุ่มเป้าหมาย",
          value: "target_group",
          width: "15%",
        },
        {
          text: "ความเร่งด่วน",
          value: "urgency",
          width: "15%",
        },
        {
          text: "สถานะ",
          value: "status",
          width: "125px",
        },
        { 
          text: "Action", 
          value: "action", 
          width: "10%", 
          align: "center" 
        },
        {
          text: '',
          value: 'data-table-expand'
        },
      ],
      headersTable1: [
        {
          text: "ลำดับที่",
          align: "center",
          value: "No",
          width: "5%",
        },
        {
          text: "ครั้งที่",
          align: "center",
          value: "appointment_no",
          width: "5%",
        },
        {
          text: "ชื่อผู้ใช้บริการ",
          align: "start",
          value: "name",
          width: "240px", 
          // width: "300px"
        },
        {
          text: "วันเวลาที่นัดหมาย",
          value: "slot_date",
          width: "15%",
        },
        {
          text: "ทีมแพทย์",
          value: "doctor_name",
          width: "160px",
        },
        {
          text: "กลุ่มเป้าหมาย",
          value: "target_group",
          width: "15%",
        },
        {
          text: "ความเร่งด่วน",
          value: "urgency",
          width: "15%",
        },
        { 
          text: "Action", 
          value: "action", 
          width: "10%", 
          align: "center" 
        },
        {
          text: '',
          value: 'data-table-expand'
        },
      ],
      headersTable2: [
        {
          text: "ลำดับที่",
          align: "center",
          value: "No",
          width: "5%",
        },
        {
          text: "ครั้งที่",
          align: "center",
          value: "appointment_no",
          width: "5%",
        },
        {
          text: "ชื่อผู้ใช้บริการ",
          align: "start",
          value: "name",
          width: "240px", 
          // width: "300px"
        },
        {
          text: "วันเวลาที่นัดหมาย",
          value: "slot_date",
          width: "15%",
        },
        {
          text: "ทีมแพทย์",
          value: "doctor_name",
          width: "160px",
        },
        {
          text: "กลุ่มเป้าหมาย",
          value: "target_group",
          width: "15%",
        },
        {
          text: "ความเร่งด่วน",
          value: "urgency",
          width: "15%",
        },
        {
          text: '',
          value: 'data-table-expand'
        },
      ],
      itemTable: [],
      loadingTable: false,
      itemOrder_type: [],
      day_menu: false,
      dateNow: moment().format("YYYY-MM-DD"),
      day_select: [],
      start_date: "",
      end_date: "",
      select_status: '',
      status_list: [
        { id: 0, text: 'สถานะเอกสารทั้งหมด', value: "" },
        { id: 1, text: 'รอเยี่ยมบ้าน', value: "1" },
        { id: 2, text: 'กำลังดำเนินการ', value: "2" },
        { id: 3, text: 'เสร็จสิ้น', value: "3" },
        { id: 4, text: 'ยกเลิก', value: "4" },
      ],
      select_urgency: "",
      urgency_list: [
        { id: 0, text: 'ความเร่งด่วนทั้งหมด', value: "" },
        { id: 1, text: 'เร่งด่วนปกติ', value: "1" },
        { id: 2, text: 'เร่งด่วนปานกลาง', value: "2" },
        { id: 3, text: 'เร่งด่วนมาก', value: "3" },
      ],
      select_appointment_no: '',
      dataIndexList: '',
    };
  },
  watch: {
    async day_select() {
      if(this.day_select.length === 2) {
        await this.displayDate()
      }
    }
  },
  computed: {
    ...mapGetters({
      organization_vuex: "organizationGetter" || [],
    }),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    display_vuetify() {
      return this.$vuetify.breakpoint.name
    },
    dateRangeText() {
      var start_year1 = ""
      var start_year2 = ""
      var end_year1 = ""
      var end_year2 = ""
      if ((this.start_date === undefined && this.end_date === undefined) || (this.start_date === '' && this.end_date === '')) {
        return ""
      } else if (this.start_date != "" && this.end_date != "" && this.start_date > this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        end_year1 = moment(this.end_date).locale("th").format("YYYY")
        end_year2 = (parseInt(end_year1) + 543).toString()
        return moment(this.end_date).locale("th").format("D MMMM " + end_year2)
            + " ~ "
            + moment(this.start_date).locale("th").format("D MMMM " + start_year2)
      } else if (this.start_date != "" && !this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        return moment(this.start_date).locale("th").format("D MMMM " + start_year2)
      } else if(this.start_date != "" && this.end_date != "" && this.start_date < this.end_date) {
        start_year1 = moment(this.start_date).locale("th").format("YYYY")
        start_year2 = (parseInt(start_year1) + 543).toString()
        end_year1 = moment(this.end_date).locale("th").format("YYYY")
        end_year2 = (parseInt(end_year1) + 543).toString()
        return moment(this.start_date).locale("th").format("D MMMM " + start_year2)
            + " ~ "
            + moment(this.end_date).locale("th").format("D MMMM " + end_year2)
      } else {
        return ""
      }
    },
  },
  mounted() {
    this.select_appointment_no = ''
    this.select_status = ''
    this.getHomeVisitList()
  },
  methods: {
    async getHomeVisitList() {
      try {
        if (this.search || this.start_date || this.end_date) {
          this.page = 1
        }

        this.expanded = []
        this.itemTable = []
        this.loadingTable = true
        this.total = 0

        var params = new URLSearchParams()
        params.append('biz_id', sessionStorage.getItem('biz_id'))
        params.append('appointment_id', '')
        params.append('keyword', this.search || '')
        params.append('status', this.status == 0 ? this.select_status : this.status)
        params.append('limit', this.limit)
        params.append('page', this.page || 1)
        params.append('urgency', this.select_urgency)
        params.append('appointment_no', this.select_appointment_no || '')

        if (this.start_date > this.end_date) {
          params.append("start_date", this.end_date || '');
          if (this.end_date) {
            params.append("end_date", this.start_date || '');
          }
        } else {
          params.append("start_date", this.start_date || '');
          if (this.end_date) {
            params.append("end_date", this.end_date || '');
          }
        }

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/get_home_visits?${params}`,
          ).then((res) => {
          // console.log('res Home VisitList',res);
            if(res.data.result == "success") {
              setTimeout(() => {
                this.summaryList = { 
                  total_all: res.data.data.pagination.total_all,
                  total_regis: res.data.data.pagination.total_waiting,
                  total_waiting: res.data.data.pagination.total_process,
                  total_complete: res.data.data.pagination.total_success,
                  total_cancel: res.data.data.pagination.total_cancel
                }
                this.total = res.data.data.pagination.total

                if (res.data.data.data.length !== 0) {

                  let data = res.data.data.data.map((ele) => {
                    return {
                      ...ele,
                      form_list: ele.form_list.reverse(),
                      loading_PDF: false
                    }
                  })

                  let data2 = data.map((ele) => {
                    return {
                      ...ele,
                      form_list: ele.form_list.map((e) => {
                        return {
                          ...e,
                          loading_PDF: false
                        }
                      })
                    }
                  })

                  this.itemTable = data2
                } else {
                  this.itemTable = []
                }
                

                this.loadingTable = false;

              }, 2000);
            } else {
              this.$swal({
                title:
                  "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>ข้อมูลผิดพลาด</span>",
                icon: "error",
                showCloseButton: false,
                showConfirmButton: false,
                background: "white",
                timer: 3000,
              });
            }
          })
        } catch(err) {
          console.log(err);
        }
    },
    mobile(mobile) {
      if (mobile == undefined || mobile == '' || mobile == null) return "-";
      if (mobile.length == 10) {
        return (
          mobile.substring(0, 3) +
          "-" +
          mobile.substring(3, 6) +
          "-" +
          mobile.substring(6, 10)
        );
      } else if (mobile.length == 9) {
        return (
          mobile.substring(0, 3) +
          "-" +
          mobile.substring(3, 6) +
          "-" +
          mobile.substring(6, 9)
        );
      }

      else return mobile;
    },
    check_form(item, value, text) {
      // console.log('item', item);
      // console.log('text', text);
      if (value.form_name == "แบบฟอร์มเยี่ยมบ้านคลินิกอบอุ่น") {
        this.$refs.registerDialog.openDialog(item, value, text);
      } else if (value.form_name == "แบบฟอร์มเยี่ยมบ้านผู้พิการ") {
        this.$refs.formDisabledPerson.openDialog(item, value, text);
      }else if (value.form_name == "แบบฟอร์มเยี่ยมบ้านผู้สูงอายุ") {
        this.$refs.formElderlyPerson.openDialog(item, value, text);
      }else {
        this.$refs.registerDialog.openDialog(item, value, text);
      }
    },
    cancel(item, text) {
      this.$refs.cancel.openDialog(item, text)
    },
    cancelForm(item, value, text) {
      this.$refs.cancelForm.openDialog(item, value, text)
    },
    booking(item) {
      this.$refs.booking.openDialog(item, 'revert')
    },
    AppointmentHomeVisit() { 
      this.$router.push({ name: "AppointmentHomeVisit" });
    },
    ExportFile() {
      this.$refs.export.openDialog()
    },
    checkIndex(index) {
      this.dataIndexList = index
    },
    PDF_Dialog(item, value, index2) {
      this.itemTable[this.dataIndexList].form_list[index2].loading_PDF = true
      this.$refs.PDF_Dialog.openDialog(item, value, this.dataIndexList, index2);
    },
    // RegisterDialog(item, text) {
    //   this.$refs.registerDialog.openDialog(item, text);
    // },
    activeGet(index) {
      this.select_status = ''
      this.status = index;
      this.page = 1;
      this.getHomeVisitList()
    },
    changePage(page) {
      this.page = page;
      this.getHomeVisitList()
    },
    checkPage() {
      const t = Math.ceil(this.total / 10);
      if (t != 0 && this.page > t) {
        this.page = 1;
      }
    },
     clearDaySelect() {
      this.day_select = [];
      this.start_date = "";
      this.end_date = "";
      this.day_menu = false;
    },
    displayDate() {
      if (!this.day_select) return ''
      return (
        (this.start_date = this.day_select[0]),
        (this.end_date = this.day_select[1])
      );
    },
    showDate(item) {
      var year1 = ""
      var year2 = ""
      year1 = moment(item).locale("th").format("YYYY")
      year2 = (parseInt(year1) + 543).toString()
      return moment(item).locale("th").format("D/MM/" + year2)
    },
    showTime(item) {
      return moment(item).locale("TH").format("LT");
    },
    loading_PDF_Dialog(data) {
      // console.log(data);
      this.itemTable[data.index].form_list[data.index2].loading_PDF = false
    },
    select_form(item, type) {
      // console.log("select_form item:", item);
      // console.log("select_form type:", type);
      this.$refs.selectFormAndPerson.openDialog(item, type)
    },
    nextListForm(item) {
      // console.log('item', item);
      if (item.form_list.length !== 0 && item.form_list.length > 5) {
        this.pageForm = 1
        this.totalForm = Math.ceil(item.form_list.length / 5)
      } else {
        this.pageForm = 1
      }
    },
    copyForm(item, value, text) {
      this.$swal
        .fire({
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun;font-weight: 700;'>ท่านต้องการยืนยันคัดลอกแบบฟอร์มใช่หรือไม่ ?</span>",
          html: "<span style='color: black;font-size: 16px;font-family: Sarabun;'>" + value.form_name +"</span>",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonText:
            "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
          cancelButtonColor: "#FFFFFF",
          showConfirmButton: true,
          confirmButtonText:
            "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
          confirmButtonColor: "#00A99D",
          allowOutsideClick: false,
        }).then( async (result) => {
          if (result.isConfirmed) {
            // console.log('item', item);
            try {
            let body = {
              biz_id: sessionStorage.getItem('biz_id'),
              appointment_id: item.appointment_id,
              form_id: value.form_id,
              form_name: value.form_name,
              userqr_id: item.userqr_id,
              select_by: sessionStorage.getItem('account_id'),
              copies_status: true
            }

            await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/select_form_home_visit`, body,
            ).then((res) => {
              if (res.data.result == 'success' && res.data.code == 200) {
                this.$swal({
                  title:
                    "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>คัดลอกข้อมูลสำเร็จ</span>",
                  icon: "success",
                  showConfirmButton: false,
                  confirmButtonText: "ปิด",
                  confirmButtonColor: "#00A99D",
                  timer: 2000,
                  timerProgressBar: true,
                }).then(() => {
                  this.status = 2
                  
                  var form = {
                    value: value,
                    item: item,
                    type: text
                  }

                  this.viewFormHomeVisit(form)
                  this.getHomeVisitList()
                  
                })
              } if (res.data.result == 'This form cannot be selected because there are still incomplete forms.' && res.data.code == 200) {
                this.$swal({
                  title:
                    "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>คัดลอกข้อมูลไม่สำเร็จ</span>",
                  html:
                    "<span style='color: black;font-size: 14px;font-family: Sarabun, sans-serif;'>เนื่องจากท่านยังมีแบบฟอร์มกำลังดำเนินการอยู่</span>",
                  icon: "error",
                  showCloseButton: false,
                  showConfirmButton: false,
                  background: "white",
                  timer: 3000,
                });
              } else {
                this.$swal({
                  title:
                    "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>คัดลอกข้อมูลไม่สำเร็จ</span>",
                  icon: "error",
                  showCloseButton: false,
                  showConfirmButton: false,
                  background: "white",
                  timer: 3000,
                });
              }
            })
            } catch (error) {
              console.log('error', error);
            }
          }
        })
    },
    viewFormHomeVisit(item) {
      // console.log("viewFormHomeVisit:", item);
      if (item.value.form_name == 'แบบฟอร์มเยี่ยมบ้านผู้พิการ') {
        this.$refs.formDisabledPerson.openDialog(item.item, item.value, item.type)
      } else if (item.value.form_name == 'แบบฟอร์มเยี่ยมบ้านผู้สูงอายุ') {
        this.$refs.formElderlyPerson.openDialog(item.item, item.value, item.type)
      } else if (item.value.form_name == 'แบบฟอร์มเยี่ยมบ้านคลินิกอบอุ่น') {
        // console.log("this.$refs.registerDialog", this.$refs.registerDialog);
        this.$refs.registerDialog.openDialog(item.item, item.value, item.type)
      } else {
         this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>ไม่พบตัวอย่างแบบฟอร์ม</span>",
          icon: "question",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    status_type(status_type) {
      if (status_type) {
        if (status_type == 'revert') {
          this.status = 1
        } else if (status_type == 'regis') {
          this.status = 1
        } else if (status_type == 'CancelForm') {
          this.status = 3
        } else if (status_type == 'CancelBooking') {
          this.status = 4
        } else if (status_type == 'draft') {
          this.status = 2
        } else if (status_type == 'finish') {
          this.status = 3
        }

        this.getHomeVisitList()
      }
    },
    checkCopyForm(item, value) {
      if ('status' in value && value.status !== '' && value.status == 'cancel') {

        var data = item.form_list.filter(e => { return e.form_name == value.form_name })
        if (data.length == 1) {
          return true
        } else {

          if (data.some(ele => { return ele.status == 'wait' || ele.status == 'success' })) {
            return false
          } else {
            return true
          }
        }
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #fbfffe;
  border-radius: 80px 0px 0px 0px;
}
.card-small {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-small2 {
  background: #fff;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}
.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}
.theme-back {
  background-color: #00a99d;
  color: #ffffff;
}

.theme-back-text {
  color: #ffffff;
  font-size: 18px;
  padding-left: 0px;
}

.theme-light-text {
  color: #00a99d;
  font-size: 18px;
  padding-left: 0px;
}
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}
::v-deep .v-image__image--cover {
  background-size: auto;
}
::v-deep .v-responsive {
  flex: none !important;
}
::v-deep .v-data-table-header {
  background: #ceefed;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 14px !important;
  align-items: start;
  /* min-height: 48px !important; */
}

::v-deep .v-select__selections {
  line-height: 25px;
}

::v-deep .image-border.v-btn:not(.v-btn--round).v-size--small {
  height: 28px;
  min-width: 38px !important;
  max-width: 38px !important;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 15px;
  background: #fff;
  /* border-collapse: separate; */
  /* border-bottom: none; */
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
  background: #ebf7f7;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){
  background: #ceefed !important;
}

/* ::v-deep .v-data-table__wrapper > table > tbody > tr > td > .theme--light.v-icon {
  color: #00a99d;
} */

::v-deep .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none;
  background: #ffffff !important;
}

.card-form_list:hover {
  box-shadow: 5px 5px #ceefed !important;
}

@media only screen and (min-width: 1264px) {
  .hide-hint {
  height: 38px;
  }
  ::v-deep .v-text-field__details {
  margin-top: 5px;
  padding-left: 5px;
  }
}

</style>